export default __webpack_public_path__ + "static/media/MushieBG.c0462bde.png";